export default __webpack_public_path__ + "e02727505f0f0433f9eca453014cf78b.gif";